import { render, staticRenderFns } from "./LoanCardex.vue?vue&type=template&id=0818092a&scoped=true&"
import script from "./LoanCardex.vue?vue&type=script&lang=js&"
export * from "./LoanCardex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0818092a",
  null
  
)

export default component.exports